import React from "react";
import { Row, Col } from "react-grid-system";
import styled from "styled-components";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function SectionPricings() {
    const [t] = useTranslation("global");
  return (
    <div>
      <Row align="center" justify="center">
        <Col md={12}>
          <CardPan>
            <h3> {t("home.free")} </h3>
            <h2> RD$0.00</h2>
            {/* <small> {t("home.receive_one_month")} </small> */}
            <hr />
            <ul>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-secundary" /> 2{" "}
                {t("categories")}
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-secundary" />{" "}
                {t("home.10_elements")}
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-secundary" />{" "}
                {t("qr_code")}
              </li>
              <li>
                <IoClose className="mx-1 text-danger" /> {t("home.non_ads")}
              </li>
              <li>
                <IoClose className="mx-1 text-danger" />{" "}
                {t("home.unlimited_categories")}
              </li>
              <li>
                <IoClose className="mx-1 text-danger" />{" "}
                {t("home.unlimited_items")}
              </li>
              <li>
                <IoClose className="mx-1 text-danger" />
                {t("home.unlimited_scans")}
              </li>
              <li>
                <IoClose className="mx-1 text-danger" />
                {t("home.technical_support")}
              </li>
            </ul>
            <Link to="/register" className="btn btn-secundary px-4 mt-3">
              Comenzar
            </Link>
          </CardPan>
        </Col>
        <Col md={12}>
          <CardPan className="active-cardpan">
            <h3>Pago único</h3>
            <h2> RD$5,600 </h2>
            <small>Pago único de por vida!</small>
            <hr />
            <ul>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" /> 2 meses
                gratis
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" />{" "}
                categorías ilimitadas
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" /> Sin
                publicidad
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" />{" "}
                Elementos ilimitados
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" /> Escaneos
                ilimitados
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" /> Código{" "}
                QR
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" />
                Crear ofertas
              </li>
              <li>
                <BsFillCheckCircleFill className="mx-1 text-success" /> Soporte
                técnico
              </li>
            </ul>
            <a
              href="https://wa.me/8299635218"
              target={"_blank"}
              className="btn btn-primary px-4 mt-3"
            >
              Elegir + 2 meses gratis
            </a>
          </CardPan>
        </Col>
      </Row>
    </div>
  );
}

const CardPan = styled.div`
  width: 100%;
  min-height: 65vh;
  background: white;
  padding: 2em 1em;
  border-radius: 12px;
  text-align: center;
  position: relative;
  margin: 1em auto;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
  a {
    position: absolute;
    bottom: -1%;
    left: -2%;
    width: 105%;
    height: 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em;
    border-radius: 12px;
  }
  h2 {
    font-size: 2em;
    margin: 0;
  }
  h3 {
    font-size: 1.2em;
  }
  hr {
    background: #3498db;
    width: 80px;
    padding: 3px 0;
    opacity: 1;
    border-radius: 20px;
    text-align: center;
    margin: 0.5em auto !important;
  }
  ul {
    list-style: none;
    padding: 0 !important;
    margin: auto !important;
    width: 80%;
    text-align: left;
    li {
      padding: 0.5em 0;
    }
  }
`;
